import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './monitoringConfig.intl.json';

export const useMonitoringConfigIntl = () => useIntlModule(messages);
